<template>
  <b-container class="mt-3">
    <b-card class="tinyCard mt-4 mb-4" :body-class="isMobile ? 'p-2' : ''">
      <standard-table ref="enumConfig"
                      :items="items"
                      :search-id="'enum-search'"
                      :fields="getStaticOptions()"
                      :search-place-holder="`${$tc('message.example', 1)}: AA999ZZ`"

                      :row-before-search="{cols: 12,sm: 12,md: 12,lg: 6,xl: 6,orderSm: 1,orderMd: 1,orderLg: 3,orderXl: 3}"
                      :row-search="{cols: 12,sm: 12,md: 12,lg: 6,xl: 6,orderSm: 2,orderMd: 2,orderLg: 1,orderXl: 1}"

                      :row-pagination="{cols: 12, sm: 12, md: 6, lg: 6, xl: 6}"
                      :row-between-pagination="{cols: 12, sm: 12, md: 1, lg: 1, xl: 1}"
                      :row-per-page="{cols: 12, sm: 12, md: 3, lg: 3, xl: 3}"
                      :row-after-per-page="{cols: 12, sm: 12, md: 2, lg: 2, xl: 2}"

                      :search-label-horizontal="false"
                      @rowEdit="showEditModal($event.item)"
                      @rowDelete="deleteSelected($event.item)"
                      fullWidth="true"
                      noContainerPadding="true">
        <b-container slot="row-before-search" class="mw-100 p-0">
          <b-row align-h="end">
            <b-col class="mb-3" cols="auto">
              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-blue" id="add-enum" v-on:click="showEditModal()" v-if="config.c">{{$t('message.add')}}</b-button>
            </b-col>
          </b-row>
        </b-container>

        <b-container :body-class="isMobile ? 'p-2' : ''" slot="row-after-per-page" class="mw-100 p-0">
          <b-row>
            <b-col>
              <b-button class="float-right mt-3 mt-md-0 mt-lg-0 mt-xl-0"
                        id="excel-button"
                        @click="$refs.enumConfig.excel(filename, getExcelFields(specialEnum))">Excel
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </standard-table>
    </b-card>

    <b-modal ref="editModal" id="editModal" hide-footer
             :title="enumeration.id
             ? `${$t('message.edit')} ${$t('message.item').toLowerCase()}`
             : `${$t('message.add')} ${$t('message.item').toLowerCase()}`">
      <validation-observer ref="mainForm" v-slot="{ invalid }">
        <b-container>
          <b-row>
            <b-col>
              <validation-provider :name="$tc('message.description', 1).toLowerCase()"
                                   :rules="{ min: 0, max: 50, required: true }"
                                   v-slot="{ valid, errors }">
                <b-form-group :label="`${$tc('message.description', 1)} (*)`"
                              label-for="input-description">
                  <b-form-input v-model="enumeration.descr"
                                :state="itemChanged ? valid : null"
                                id="input-description"
                                type="text">
                  </b-form-input>

                  <div v-if="itemChanged && !valid" class="my-invalid-feedback"> <h6>{{ first(errors) }}</h6></div>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>

          <b-row v-if="specialEnum">
            <b-col>
              <b-form-group :label="`${$tc('message.notificationGroup', 1)}`"
                            label-for="input-notification">
                <model-list-select id="input-notification"
                                   option-text="descr"
                                   option-value="id"
                                   :placeholder="recipientOptions && recipientOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                   v-model="enumeration.notificationRecipientId"
                                   :list="recipientOptions">
                </model-list-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="specialEnum">
            <b-col>
              <b-form-group :label="`${$tc('message.reminderGroup', 1)}`"
                            label-for="input-reminder">
                <model-list-select id="input-reminder"
                                   option-text="descr"
                                   option-value="id"
                                   :placeholder="recipientOptions && recipientOptions.length !== 0 ? $t('message.selectOption') : $t('message.noOption')"
                                   v-model="enumeration.reminderRecipientId"
                                   :list="recipientOptions">
                </model-list-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="specialEnum">
            <b-col class="d-block c-red" cols="12">
              {{$t('info.enumConfig1')}}
            </b-col>

            <b-col class="d-block c-red mt-1" cols="12">
              {{$t('info.enumConfig2')}}
            </b-col>
          </b-row>

          <b-row class="my-border-top">
            <b-col class="mt-3 justify-content-end d-flex">
              <!-- config[crud], create - read - update - delete -->
              <b-button class="b-c-green mr-2" id="save-and-close"
                        v-if="enumeration.id ? config.u : config.c"
                        v-on:click="saveAndClose" :disabled="!enumeration.descr || !itemChanged || invalid">{{$t('message.saveClose')}}</b-button>

              <b-button class="b-c-green" id="close" v-on:click="pushBack()">{{$t('message.close')}}</b-button>
            </b-col>
          </b-row>
        </b-container>
      </validation-observer>
    </b-modal>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { cloneDeep, find, orderBy, first } from 'lodash'
import routeViews from '../../router-views'

export default {
  name: 'ConfigurationsEnums',
  watch: {
    $route (newVal) {
      this.enumSwitcher = newVal && newVal.meta && newVal.meta.enumSwitcher
      const foundedRoute = this.getCurrentRoute(routeViews.sidebarItems(this), newVal.path)
      this.filename = foundedRoute ? foundedRoute.title.replace(/ /g, '') : '_error_'
      this.fetchData()
    }
  },
  created () {
    this.fetchData()
  },
  mounted () {
    this.updateLinks()
    this.$nextTick(() => {
      this.$root.$on('change-lang', () => {
        if (this.$el.isConnected) {
          this.updateLinks()
          this.getStaticOptions()
          const foundedRoute = this.getCurrentRoute(routeViews.sidebarItems(this), this.$route.path)
          this.filename = foundedRoute ? foundedRoute.title.replace(/ /g, '') : '_error_'
        }
      })
      this.$root.$on('resize', () => {
        this.checkWindowWidth()
      })
    })
  },
  data () {
    const enumSwitcher = this.$route && this.$route.meta && this.$route.meta.enumSwitcher
    const foundedRoute = this.getCurrentRoute(routeViews.sidebarItems(this), this.$route.path)
    const filename = foundedRoute ? foundedRoute.title.replace(/ /g, '') : '_error_'
    const config = this.$route.meta.config

    return {
      config,
      first,
      enumSwitcher,
      filename,
      isMobile: false,
      fields: [],
      enumeration: { descr: null },
      items: [],
      itemChanged: false,
      watcher: null,
      recipientOptions: [],
      specialEnum: false,
      links: enumSwitcher === 'operation' || enumSwitcher === 'service_type'
        ? ['/recipients']
        : []
    }
  },
  methods: {
    clickedLink (link) {
      this.$router.push(link.href)
    },
    updateLinks () {
      const links = []
      this.links.forEach(link => {
        links.push({ href: link })
      })
      this.$root.$emit('change-links', links)
    },
    getStaticOptions () {
      const fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'delete', label: '', hideInTable: !this.config.d },
        { key: 'descr', label: `${this.$t('message.description')}`, sortable: true, sortDirection: 'desc' },
        { key: 'reminderGroupDescr', label: `${this.$tc('message.reminderGroup', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: !this.specialEnum, hideInExcel: !this.specialEnum },
        { key: 'notificationRecipientDescr', label: `${this.$tc('message.notificationGroup', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: !this.specialEnum, hideInExcel: !this.specialEnum },
        { key: 'reminderGroupMail', label: `${this.$tc('message.reminderGroup', 1)} ${this.$tc('message.email', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true, hideInExcel: true },
        { key: 'notificationRecipientMail', label: `${this.$tc('message.notificationGroup', 1)} ${this.$tc('message.email', 1).toLowerCase()}`, sortable: true, sortDirection: 'desc', hideInTable: true, hideInExcel: true }
      ]
      this.fields = fields
      return fields
    },
    getExcelFields (isSpecial) {
      const fields = [
        // config[crud], create - read - update - delete
        { key: 'edit', label: '', hideInTable: !this.config.u && !this.config.r },
        { key: 'delete', label: '', hideInTable: !this.config.d },
        { key: 'descr', label: `${this.$t('message.description')}`, sortable: true, sortDirection: 'desc' }
      ]
      if (isSpecial) {
        fields.push({ key: 'reminderGroupDescr', label: `${this.$tc('message.reminderGroup', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: !isSpecial, hideInExcel: !isSpecial })
        fields.push({ key: 'notificationRecipientDescr', label: `${this.$tc('message.notificationGroup', 1)}`, sortable: true, sortDirection: 'desc', hideInTable: !isSpecial, hideInExcel: !isSpecial })
      }
      return fields
    },
    getCurrentRoute (route, path) {
      if (route.href === path) return route
      if (route.child) return this.getCurrentRoute(route.child, path)
      if (route.length) {
        let foundedRoute = null
        route.forEach(innerRoute => {
          const routeTry = this.getCurrentRoute(innerRoute, path)
          if (routeTry) {
            foundedRoute = routeTry
          }
        })
        return foundedRoute
      }
      return null
    },
    checkWatcher () {
      if (this.watcher) {
        this.watcher()
      }
      this.itemChanged = false
    },
    addWatcher () {
      this.watcher = this.$watch('enumeration', () => {
        this.itemChanged = true
      }, { deep: true })
    },
    showEditModal (item) {
      this.checkWatcher()
      this.$refs.editModal.show()
      if (item) {
        this.enumeration = cloneDeep(item)
      } else {
        this.enumeration = { descr: null }
      }
      this.addWatcher()
    },
    fetchData () {
      this.specialEnum = false
      this.$root.$emit('activeLoader', true)
      this.checkSpecialEnum()
    },
    checkSpecialEnum () {
      if (this.enumSwitcher === 'service_type' || this.enumSwitcher === 'operation') {
        this.specialEnum = true

        Vue.myGet(this, '/recipients_list', 'recipients').then((groups) => {
          const editedItems = [{ descr: groups && groups.length !== 0 ? this.$t('message.selectOption') : this.$t('message.noOption'), id: '' }]
          groups.forEach(group => {
            const editedGroup = group
            let editedRecipients = ''
            editedGroup.recipients.forEach((item, index) => {
              editedRecipients += `${item}${index + 1 === editedGroup.recipients.length ? '' : ', '}`
            })
            editedGroup.recipients = editedRecipients
            editedItems.push(editedGroup)
          })
          this.recipientOptions = editedItems
          this.$root.$emit('activeLoader', false)
          this.getTableData()
        }).catch(error => {
          Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
          this.getTableData()
        })
      } else {
        this.getTableData()
      }
    },
    getTableData () {
      const axiosArray = []
      axiosArray.push(this.getStaticOptions())
      Vue.myAll(axiosArray).then(() => {
        if (this.enumSwitcher) {
          return Vue.myGet(this, `/enums/${this.enumSwitcher}`, 'data').then((types) => {
            const recipients = this.recipientOptions
            const editedItems = []
            types.forEach(type => {
              const editedType = type
              if (recipients) {
                if (type.reminderRecipientId) {
                  const foundedRecipient = find(recipients, obj => obj.id === type.reminderRecipientId)
                  if (foundedRecipient) {
                    editedType.reminderGroupDescr = foundedRecipient.descr
                    editedType.reminderGroupMail = foundedRecipient.recipients
                  }
                }
                if (type.notificationRecipientId) {
                  const foundedRecipient = find(recipients, obj => obj.id === type.notificationRecipientId)
                  if (foundedRecipient) {
                    editedType.notificationRecipientDescr = foundedRecipient.descr
                    editedType.notificationRecipientMail = foundedRecipient.recipients
                  }
                }
              }
              editedItems.push(editedType)
            })
            this.items = orderBy(editedItems, 'descr')
            this.$root.$emit('activeLoader', false)
            return true
          }).catch(error => {
            Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
            this.$root.$emit('activeLoader', false)
            return false
          })
        } else {
          this.$root.$emit('activeLoader', false)
          return false
        }
      })
    },
    checkWindowWidth () {
      const size = Vue.myGetWindowSize()
      this.isMobile = (size !== 'md' && size !== 'lg' && size !== 'xl')
    },
    saveAndClose () {
      const hasId = !!this.enumeration.id
      const item = cloneDeep(this.enumeration)
      const path = `/enums/${this.enumSwitcher}${hasId ? '/' + this.enumeration.id : ''}`

      if (!item.reminderRecipientId) item.reminderRecipientId = null
      if (!item.notificationRecipientId) item.notificationRecipientId = null

      Vue.putOrPost(this, hasId, path, item).then(() => {
        this.itemChanged = false
        this.pushBack()
        Vue.success(this, `${this.$tc('message.edit')} ${this.$tc('message.done', 2).toLowerCase()}`)
        this.$router.push({ name: 'RefreshPage', params: { redirect: `/configuration/${this.enumSwitcher}` } })
      }).catch(error => {
        Vue.manageErrors(this, error, Vue.getDimetiorHttpCode())
        this.pushBack()
      })
    },
    deleteSelected (item) {
      const obj = {
        path: `/enums/${this.enumSwitcher}/${item.id}`,
        description: item.descr,
        redirect: this.$route.path
      }

      this.$root.$emit('deleteItem', obj, 1)
    },
    pushBack () {
      this.$refs.editModal.hide('button')
      this.enumeration = { descr: null }
    }
  }
}
</script>

<style scoped>

</style>
